import Repository from './repository'

export default {
    TreinadoresGet () {
        return Repository.get('coaches')
    },
    TreinadorGetId (id) {
        return Repository.get(`coaches/${id}`)
    },
    TreinadorPost (item) {
        return Repository.post('coaches', item)
    },
    TreinadorPut (id, item) {
        return Repository.put(`coaches/${id}`, item)
    },
    TreinadorDelete (id) {
        return Repository.delete(`coaches/${id}`)
    }
}

